'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropTypes = require('../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _server = require('react-dom/server');

var _server2 = _interopRequireDefault(_server);

var _jssThemeReactor = require('jss-theme-reactor');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _toString = function _toString(component) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _server2['default'].renderToStaticMarkup((0, _react.createElement)(component, props)).replace(/[\r\n]+/g, '');
};

// https://codepen.io/tigt/post/optimizing-svgs-in-data-uris
var _toDataURI = function _toDataURI(component, props) {
  return 'data:image/svg+xml,' + encodeURIComponent(
  // encode URL-unsafe characters
  _toString(component, props) // render to static markup
  .replace(/\n+/g, '') // remove newlines
  .replace(/%20/g, ' ') // put spaces back in
  .replace(/%3D/g, '=') // ditto equals signs
  .replace(/%3A/g, ':') // ditto colons
  .replace(/%2F/g, '/') // ditto slashes
  .replace(/%22/g, "'") // replace quotes with apostrophes (may break certain SVGs)
  );
};

// Possible improvements:
//   * Lowercase the hex-escapes for better gzipping
//   * Replace stuff like `fill="%23000"` with `fill="black"`

var _toURL = function _toURL(component, props) {
  return 'url(\'' + _toDataURI(component, props) + '\')';
};

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('SvgIcon', function (theme) {
  return {
    svgIcon: {
      display: 'inline-block',
      color: 'currentColor',
      fill: 'currentColor',
      height: '1em',
      width: '1em',
      userSelect: 'none',
      transition: theme.transitions.create(['color', 'fill'])
    },
    highlight: {
      color: theme.typography.highlight.color,
      fill: theme.typography.highlight.color
    },
    disabled: {
      color: theme.typography.disabled.color,
      fill: theme.typography.disabled.color
    },
    error: {
      color: theme.typography.error.color,
      fill: theme.typography.error.color
    },
    success: {
      color: theme.typography.success.color,
      fill: theme.typography.success.color
    },
    secondary: {
      color: theme.typography.secondary.color,
      fill: theme.typography.secondary.color
    }
  };
});

// eslint-disable-next-line react/display-name
var SvgIcon = (_temp = _class = function (_PureComponent) {
  _inherits(SvgIcon, _PureComponent);

  function SvgIcon() {
    _classCallCheck(this, SvgIcon);

    return _possibleConstructorReturn(this, (SvgIcon.__proto__ || Object.getPrototypeOf(SvgIcon)).apply(this, arguments));
  }

  _createClass(SvgIcon, [{
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            children = _props.children,
            classNameProp = _props.className,
            disabled = _props.disabled,
            error = _props.error,
            success = _props.success,
            highlight = _props.highlight,
            secondary = _props.secondary,
            viewBox = _props.viewBox,
            other = _objectWithoutProperties(_props, ['children', 'className', 'disabled', 'error', 'success', 'highlight', 'secondary', 'viewBox']);

        var _ref = this.context || {},
            styleManager = _ref.styleManager;

        var classPicker = {};

        if (styleManager) {
          var _classPicker;

          var classes = styleManager.render(styleSheet);
          classPicker = (_classPicker = {}, _defineProperty(_classPicker, classes.svgIcon, true), _defineProperty(_classPicker, classes.secondary, secondary), _defineProperty(_classPicker, classes.highlight, highlight), _defineProperty(_classPicker, classes.disabled, disabled), _defineProperty(_classPicker, classes.error, error), _defineProperty(_classPicker, classes.success, success), _classPicker);
        }

        var className = (0, _classnames2['default'])(classPicker, classNameProp);

        return _react2['default'].createElement(
          'svg',
          _extends({
            className: className,
            preserveAspectRatio: 'xMinYMid',
            viewBox: viewBox,
            xmlns: 'http://www.w3.org/2000/svg'
          }, other),
          children
        );
      }

      return render;
    }()
  }], [{
    key: 'toString',
    value: function () {
      function toString(props) {
        return _toString(this, props);
      }

      return toString;
    }()
  }, {
    key: 'toDataURI',
    value: function () {
      function toDataURI(props) {
        return _toDataURI(this, props);
      }

      return toDataURI;
    }()
  }, {
    key: 'toURL',
    value: function () {
      function toURL(props) {
        return _toURL(this, props);
      }

      return toURL;
    }()
  }]);

  return SvgIcon;
}(_react.PureComponent), _class.muiName = 'SvgIcon', _class.propTypes = {
  /**
   * Elements passed into the SVG Icon.
   */
  children: _PropTypes2['default'].node,
  /**
   * The css class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * If `true`, the icon will use the theme's disabled color.
   */
  disabled: _PropTypes2['default'].bool,
  /**
   * If `true`, the icon will use the theme's error color.
   */
  error: _PropTypes2['default'].bool,
  /**
   * If `true`, the icon will use the theme's success color.
   */
  success: _PropTypes2['default'].bool,
  /**
   * If `true`, the icon will use the theme's highlight color.
   */
  highlight: _PropTypes2['default'].bool,
  /**
   * If `true`, the icon will use the theme's secondary color.
   */
  secondary: _PropTypes2['default'].bool,
  /**
   * Allows you to redefine what the coordinates without units mean inside an svg element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the svg will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */
  viewBox: _PropTypes2['default'].string
}, _class.defaultProps = {
  disabled: false,
  error: false,
  highlight: false,
  secondary: false,
  success: false,
  viewBox: '0 0 24 24'
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager
}, _temp);
exports['default'] = SvgIcon;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/SvgIcon/SvgIcon.js
// module id = 2
// module chunks = 32